export * from './provider/provider-appointment/provider-appointment.component';
export * from './provider/add-appointment/add-appointment.component';
export * from './provider/add-attribute/add-attribute.component';
export * from './transcriber/transcriber-appointment/transcriber-appointment.component';
export * from './add-payor/add-payor.component';
